import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import { data, header } from '../_reducers';

export default (history) => combineReducers({
  router: connectRouter(history),
  data,
  header
});
